export { default } from './ShopStyles';
